var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.color,attrs:{"type":_vm.type || 'button',"disabled":_vm.disabled || _vm.loading},on:{"click":_vm.emitClick}},[(_vm.loading)?_c('div',{staticClass:"loader-2"}):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }